import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';

export const useStyles = makeStyles<Theme>()((theme) => ({
  avatarWrapper: {
    '& .MuiAvatar-colorDefault': {
      backgroundColor: '#ff5722 !important',
    },
  },

  pendingAvatar: {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    border: '1px dashed #898793',
  },

  roundIcon: {
    borderRadius: '50%',
  },

  squareIcon: {
    borderRadius: '4px',
  },
}));
